
export default function PageTitle({title="Section Title"}:{title:string}) {
  return (
    <div className="flex gap-3 pt-3 pb-6 border-b border-primary">
      <div className="w-10 md:w-20 h-1 bg-primary mt-5"></div>
      <h1 className="text-2xl font-bold">{title}</h1>
    </div>
  );
}
